import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of, BehaviorSubject } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { environment } from '@environments/environment';


@Injectable({
    providedIn: 'root'
})
export class SectorPageService {
    constructor(private http: HttpClient) { }
    public categoriesSubject$: BehaviorSubject<any> = new BehaviorSubject(null);
    readonly categories$: Observable<any[]> = this.categoriesSubject$.asObservable();
    public colorsSubject$: BehaviorSubject<any> = new BehaviorSubject(null);
    readonly sectorColors$: Observable<any> = this.colorsSubject$.asObservable();
    public hasProfessionalsSubject$: BehaviorSubject<any> = new BehaviorSubject(false);
    readonly hasProfessionals$: Observable<any> = this.hasProfessionalsSubject$.asObservable();

    getSector(id): Observable<any> {
        return this.http.get<any>(`${environment.apiUrl}/homepage/sector/${id}`).pipe(
            tap(response => {
                this.categoriesSubject$.next(response.categories ?? []);
                this.colorsSubject$.next(response.colors ?? {});
                this.hasProfessionalsSubject$.next(response.hasProfessionals ?? false);
            })
        );
    }

    get categories() {
        return this.categoriesSubject$.value;
    }

    get sectorColors() {
        return this.colorsSubject$.value;
    }
}
